export class MoengageClient {
  constructor(apiKey) {
    this.apiKey = apiKey;
  }

  log(event, data) {
    if (!window.Moengage) return;

    console.log("i-log> moengage log", event);
    window.Moengage.track_event(event, { integration: 'React' });
  }

  identify(user) {
    console.log("i-log> identify", user);
  }
}
